import { ImportConfigurationRepository } from '../data/import-configuration-repository';
import { ColumnMappingDeleteResponse } from '../types/import-configuration-types';

/**
 * Use case for deleting a column mapping
 */
export class DeleteColumnMappingUseCase {
  constructor(private readonly repository: ImportConfigurationRepository) {}

  async execute(columnId: number): Promise<ColumnMappingDeleteResponse> {
    return this.repository.deleteColumnMapping(columnId);
  }
}
